import { Div } from '@tblabs/truffle';

export class Row extends Div
{
    constructor(...components)
    {
        super("row");
    
        this.Append(...components)
    }
}

export class CenteredRow extends Div
{
    constructor(...components)
    {
        super("row");
        this.TextAlignCenter()
    
        this.Append(...components)
    }
}

export class LeftAlignedRow extends Div
{
    constructor(...components)
    {
        super("row");
        this.TextAlignLeft()
    
        this.Append(...components)
    }
}
